module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "development"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.hadingtext))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.elements), function(element, index) {
    return _c('div', {
      staticClass: "col-l-6 col-m-6 col-s-12"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(element.title))]), _vm._v(" "), _c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(element.text)
      }
    })])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33ae19b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlockDevelopment.vue
// module id = 325
// module chunks = 0